import React, { FC } from "react";
import { Typography } from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import { ReactComponent as ProgramDetails } from "../../../../assets/svg/program-details.svg";
import { ReactComponent as AccordionArrow } from "../../../../assets/svg/accordion-arrow.svg";
import { DetailType } from "../../constants";
import { IconWithText } from "../IconWithText";
import Masker from "../../../../components/Masker/Masker";
import { CourseDetailType } from "../../../language-course/types";

const useStyles = makeStyles(() => ({
  programsContainer: {
    marginTop: 16,
  },
  accordion: {
    "& .MuiAccordionSummary-content": {
      margin: 0,
    },
    "& .MuiAccordionSummary-root.Mui-expanded": {
      minHeight: 51,
    },
    "& .MuiTypography-body1": {
      fontWeight: 500,
      color: "#231F20",
    },
  },
}));

const Accordion = withStyles({
  root: {
    borderRadius: 15,
    marginTop: 16,
    boxShadow: "none",
    border: "solid 1px #C5C5C5",
    padding: 0,
    position: "relative",
    "&:before": {
      display: "none",
    },
  },
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    cursor: "pointer",
    padding: "9px 32px",
  },
})(MuiAccordionSummary);

const AccordionContent = withStyles(() => ({
  root: {
    display: "block",
    padding: "0px 32px",
    borderTop: "solid 1px #C5C5C5",
    fontSize: 16,
    color: "#231F20",
  },
}))(MuiAccordionDetails);

interface ProgramDetailsProps {
  programDetails: { name: string; content: string; type: number }[];
  title?: string;
  isMasked?: boolean;
  notMaskedFields?: (DetailType | CourseDetailType)[];
}

export const ViewMoreDetailsWidget: FC<ProgramDetailsProps> = ({
  programDetails,
  title = "Program Details",
  isMasked = false,
  notMaskedFields = [],
}) => {
  const classes = useStyles();

  const [expanded, setExpanded] = React.useState<DetailType>();
  const handleExpand = (panel) => (_, newExpanded) => {
    setExpanded(newExpanded ? panel.type : false);
  };

  return (
    <div>
      <IconWithText Icon={ProgramDetails} title={title} />
      <div className={classes.programsContainer}>
        {programDetails.map((item) => (
          <Accordion
            key={item.type}
            expanded={expanded === item.type}
            onChange={handleExpand(item)}
            className={classes.accordion}
          >
            <AccordionSummary expandIcon={<AccordionArrow />}>
              <Typography>{item.name}</Typography>
            </AccordionSummary>
            <AccordionContent>
              {expanded === item.type && (
                <Masker
                  isMasked={isMasked && !notMaskedFields.includes(item.type)}
                >
                  <div dangerouslySetInnerHTML={{ __html: item.content }} />
                </Masker>
              )}
            </AccordionContent>
          </Accordion>
        ))}
      </div>
    </div>
  );
};
